/* eslint-disable no-unused-vars */
import GlobalStore from "@ipru-common/store/GlobalStore";
import { convertToDateTime, readQueryParams } from "../CommonFunctions";
import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { yesNo } from "../SavingsAppForm/SavingAppFormsUtils";

const getSaralPensionNetCoreInput = () => {
  const { quoteFormData, calculatorFormData, existingCustomer, currentPageStep, appFormData } =
    GlobalStore.getSnapshot();
  const queryParams = readQueryParams();
  const UID = queryParams.get("UID") || "480";
  const isForSingle = quoteFormData?.pensionFor === OPTION_VALUES.PENSION_FOR.ME;

  let saralInput = {
    existing_cust: calculatorFormData?.employeeId || existingCustomer ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    nps_flag: "No",
    isnri: calculatorFormData?.nri === OPTION_VALUES.NRI_YES ? "1" : "0",
    lms_nri: calculatorFormData?.nri,
    investment_amount: quoteFormData?.investAmount,
    gender: calculatorFormData?.gender,
    maritalstatus: calculatorFormData?.maritalStatus,
    age: calculatorFormData?.age,
    dob: convertToDateTime(calculatorFormData?.user_dob),
    mobileno: calculatorFormData?.mobileno,
    emailid: calculatorFormData?.emailid,
    city: calculatorFormData?.city,
    occupation: calculatorFormData?.calc_occupation,
    annuity_frequency: quoteFormData?.receivePensionFrequency,
    annuity_option: isForSingle
      ? "LIFE ANNUITY WITH RETURN OF PURCHASE PRICE"
      : "JOINT LIFE, LAST SURVIVOR WITH RETURN OF PURCHASE PRICE",
    spouse_dob: quoteFormData?.saralSpouseDetails?.dob,
    spouse_name: quoteFormData?.saralSpouseDetails?.name,
    spouse_gender: quoteFormData?.saralSpouseDetails?.gender,
    brochure_selected: "",
    tollfree_selected: "",
    qdata: queryParams?.get("qdata") ?? "",
    qdata_pasa: "",
    sourceurl: window.location.origin + window.location.pathname,
    uid: UID,
    step: "",
    trai_flag: yesNo(calculatorFormData?.trai_flag),
    productid: calculatorFormData?.productCode,
    staff: calculatorFormData?.staff === OPTION_VALUES.STAFF_N ? OPTION_VALUES.N_NO : OPTION_VALUES.Y_YES,

    joint_life_name: quoteFormData?.joint_life_name ?? "",
    joint_life_dob: quoteFormData?.joint_life_dob ?? "",
    joint_life_relationship: appFormData?.personalDetails?.propDetails?.propRel ?? "",
    annualincome: "",

    // Additional Important Keys
    isenglish: "TRUE",
    currentPageStep: currentPageStep,

    annuity_type: "",
    education: isForSingle
      ? (appFormData?.personalDetails?.highest_education ?? "")
      : appFormData?.personalDetails?.propDetails?.propEdu,
    name_of_organisation: isForSingle
      ? (appFormData?.personalDetails?.organisation_name ?? "")
      : appFormData?.personalDetails?.propDetails?.propnameOfOrg,
    organisation_type: isForSingle
      ? (appFormData?.personalDetails?.organisation_type ?? "")
      : appFormData?.personalDetails?.propDetails?.proporgType,
    primary_pension_receiver_education: isForSingle
      ? (appFormData?.personalDetails?.highest_education ?? "")
      : appFormData?.personalDetails?.propDetails?.propEdu,
    primary_pension_receiver_name: isForSingle
      ? (appFormData?.personalDetails?.full_name ?? "")
      : (appFormData?.personalDetails?.propDetails?.propFullNm ?? ""),
    primary_pension_receiver_occupation: isForSingle
      ? (appFormData?.personalDetails?.occupation ?? "")
      : (appFormData?.personalDetails?.propDetails?.propocc ?? ""),
    secondary_pension_receiver_education: isForSingle ? "" : (appFormData?.personalDetails?.highest_education ?? ""),
    secondary_pension_receiver_name: isForSingle ? "" : (appFormData?.personalDetails?.full_name ?? ""),
    secondary_pension_receiver_occupation: isForSingle ? "" : (appFormData?.personalDetails?.occupation ?? ""),
    secondary_pension_receiver_mobile_no: isForSingle ? "" : (appFormData?.personalDetails?.mobile_number ?? ""),
    pran_number: appFormData?.personalDetails?.pran_number ?? "",
    pan_no: isForSingle
      ? (appFormData?.personalDetails?.pan_number ?? "")
      : (appFormData?.personalDetails?.propDetails?.propPanNo ?? ""),
    nominee: appFormData?.personalDetails?.nominee_fullname ?? "",
    nominee_dob: appFormData?.personalDetails?.nominee_dob ?? "",
    nominee_relationship: appFormData?.personalDetails?.nominee_relationship ?? "",
    nominee_gender: appFormData?.personalDetails?.nominee_gender ?? "",
    identity_proof_used: appFormData?.personalDetails?.identity_proof ?? "",
    age_proof_used: appFormData?.personalDetails?.age_proof ?? "",
    payoutdetails: "",
    appno: appFormData.appNO,
    submit_button_flag: "",
    traiflag: "",
  };

  return saralInput;
};

export default getSaralPensionNetCoreInput;
